// @flow
import { AppType } from 'src/constants/integration';
import { processRes } from 'src/helpers/actions-helper';
import { getJSON } from 'redux-api-middleware';
import { trackFSEvent } from 'src/integrations/fullStory';

import apiService from 'src/services/api-service';
import {
  HANDLE_CHANGE_SWITCH_APP,
  HANDLE_CONTINUE_SWITCH_APP_REQUEST,
  HANDLE_CONTINUE_SWITCH_APP_SUCCESS,
  HANDLE_CONTINUE_SWITCH_APP_FAILURE,
  HANDLE_CHANGE_REMOVE_APP,
  HANDLE_CONTINUE_REMOVE_APP_REQUEST,
  HANDLE_CONTINUE_REMOVE_APP_SUCCESS,
  HANDLE_CONTINUE_REMOVE_APP_FAILURE,
  MARK_OPEN_FULLSCREEN,
  HANDLE_REVIEWS_IO_ATTR_REQUEST,
  HANDLE_REVIEWS_IO_ATTR_SUCCESS,
  HANDLE_REVIEWS_IO_ATTR_FAILURE
} from 'stores/flow-type/app-integration.type';

import {
  HANDLE_RE_RANKING_REQUEST,
  HANDLE_RE_RANKING_SUCCESS,
  HANDLE_RE_RANKING_FAILURE,
  HANDLE_REVIEWS_IO_CONNECT_REQUEST,
  HANDLE_REVIEWS_IO_CONNECT_SUCCESS,
  HANDLE_REVIEWS_IO_CONNECT_FAILURE,
} from 'stores/flow-type/oauth.type';

export const handleChangeSwitchApp = (appType, appName, appKey = '') => {
  return { type: HANDLE_CHANGE_SWITCH_APP, meta: { appType, appName, appKey } };
};

export const handleContinueSwitchApp = (appType, appName, appKey, i18n) => {
  const params = { appType, appName };
  const body = { appType, appName, appKey };

  const route = 'admin-v3.theme-setup.integration';

  return apiService.sendRequest(route, { params, body }, [
    HANDLE_CONTINUE_SWITCH_APP_REQUEST,
    {
      type: HANDLE_CONTINUE_SWITCH_APP_SUCCESS,
      payload: async (action, state, res) => {
        if (appType === AppType.reviews) {
          const data = await processRes(
            res,
            'custom-with-sync',
            i18n.translate('AdminHTML.Integration.Actions.handleContinueSwitchAppReview_Success'),
            i18n
          );

          // Track Full Story event
          trackFSEvent('Turn on Integration', {
            feature: 'Integration',
            appName: params?.appName
          });

          return { data };
        } else if (appType === AppType.labels) {
          // Track Full Story event
          trackFSEvent('Turn on Integration', {
            feature: 'Integration',
            appName: `Product label: ${params?.appName}`
          });
        }
      }
    },
    {
      type: HANDLE_CONTINUE_SWITCH_APP_FAILURE,
      payload: async (action, state, res) => {
        const errorResult = await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Integration.Actions.handleContinueSwitchAppReview_Failure'),
          i18n
        );

        return errorResult;
      }
    }
  ]);
};

export const handleChangeRemoveApp = (appType, appName) => {
  return { type: HANDLE_CHANGE_REMOVE_APP, meta: { appType, appName } };
};

export const handleContinueRemoveApp = (appType, appName, i18n) => {
  const params = { appType, appName };
  const body = { appType };

  const route = 'admin-v3.theme-setup.integration';

  return apiService.sendRequest(route, { params, body }, [
    HANDLE_CONTINUE_REMOVE_APP_REQUEST,
    {
      type: HANDLE_CONTINUE_REMOVE_APP_SUCCESS,
      payload: async (action, state, res) => {
        if (appType === AppType.reviews) {
          const data = await processRes(
            res,
            'custom-with-sync',
            i18n.translate('AdminHTML.Integration.Actions.handleContinueRemoveAppReview_Success'),
            i18n
          );

          // Track Full Story event
          trackFSEvent('Remove Integration', {
            feature: 'Integration',
            appName: params?.appName
          });

          return { data };
        }
      }
    },
    {
      type: HANDLE_CONTINUE_REMOVE_APP_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Integration.Actions.handleContinueRemoveAppReview_Failure'),
          i18n
        )
    }
  ]);
};

export const handleChangeApp = (currentAppIntegration, appType, appName) => {
  return currentAppIntegration?.[appType] === appName
    ? handleChangeRemoveApp(appType, appName)
    : handleChangeSwitchApp(appType, appName);
};

export const handleReviewsIoConnect = (status, i18n) => {
  const body = { status };
  const route = 'admin-v3.third-party-integration.reviewsio-connect';

  return apiService.sendRequest(route, { body }, [
    HANDLE_REVIEWS_IO_CONNECT_REQUEST,
    {
      type: HANDLE_REVIEWS_IO_CONNECT_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: HANDLE_REVIEWS_IO_CONNECT_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Integration.Actions.handleReviewsIoConnect_Failure'),
          i18n
        )
    }
  ]);
};

export const handleReviewsIoAttr = i18n => {
  const route = 'admin-v3.third-party-integration.reviewsio-attributes';
  return apiService.sendRequest(route, {}, [
    HANDLE_REVIEWS_IO_ATTR_REQUEST,
    {
      type: HANDLE_REVIEWS_IO_ATTR_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: HANDLE_REVIEWS_IO_ATTR_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Integration.Actions.handleReviewsIoAttr_Failure'),
          i18n
        )
    }
  ]);
};

export const handleReRanking = (status, i18n) => {
  const body = { status };
  const route = 'admin-v3.third-party-integration.trigger-re-ranking';

  return apiService.sendRequest(route, { body }, [
    HANDLE_RE_RANKING_REQUEST,
    {
      type: HANDLE_RE_RANKING_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: HANDLE_RE_RANKING_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Integration.Actions.handleReRanking_Failure'),
          i18n
        )
    }
  ]);
};

/**
 * call mark app in fullscreen mode
 * @return {object} The RSAA object for API middleware
 */
export const handleOpenFullscreen = isOpenFullScreen => {
  return { type: MARK_OPEN_FULLSCREEN, payload: isOpenFullScreen };
};
